export abstract class BaseGameData<T = any> {
    protected dailyGames: Array<T>;

    constructor(dailyGames: Array<T>) {
        this.dailyGames = dailyGames;
    }

    getDailyGame(gameNumber: number): T | null {
        const index = gameNumber - 1;
        if (index < 0 || index >= this.dailyGames.length) {
            return null;
        }
        return this.dailyGames[index];
    }

    getAllDailyGames(): Array<T> {
        return [...this.dailyGames];
    }
}